// extracted by mini-css-extract-plugin
export default {"wrapper":"nav-items-module--wrapper--2291a","level1":"nav-items-module--level1--d2c3b","item":"nav-items-module--item--e53df","level2":"nav-items-module--level2--09952"};